import { CheckCircle2, AlertTriangle, Loader2 } from "lucide-react";

export function ScriptFitIndicator({ fit, checking }) {
  if (checking && !fit) {
    return (
      <span data-testid="script-fit-indicator" className="inline-flex items-center gap-1 text-[11px] text-white/50">
        <Loader2 className="w-3 h-3 animate-spin" /> Checking length...
      </span>
    );
  }
  if (!fit) return null;
  const tone = fit.fits ? "text-emerald-400" : "text-amber-400";
  const Icon = fit.fits ? CheckCircle2 : AlertTriangle;
  return (
    <span data-testid="script-fit-indicator" data-fits={fit.fits ? "true" : "false"} className={`inline-flex items-center gap-1 text-[11px] transition-colors ${tone}`}>
      <Icon className="w-3 h-3" />
      {fit.word_count}/{fit.max_words} words · {fit.fits ? `fits ${fit.duration}s` : `too long for ${fit.duration}s`}
    </span>
  );
}
